import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { useLocation } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import List from '@mui/material/List';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { Container, Typography, useMediaQuery } from '@mui/material';
import "../../css/Navbar/Navbar.css"
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
/* import PhoneIcon from '@mui/icons-material/Phone'; */
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import { FaLinkedinIn } from "react-icons/fa";
import LogoColor from "../../Image/Logo.png"
import { Link } from 'react-router-dom';


const menuItems = [
  { name: 'Inicio', path: '/' },
  { name: 'Productos', path: '/producto' },
  { name: 'Nosotros', path: '/nosotros' },
  { name: 'Servicio', path: '/servicio' },
  { name: 'Cotiza aquí', path: '/contacto', isButton: true },
];


export const Menu = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const [activeItem, setActiveItem] = useState(location.pathname);
  const isMobile = useMediaQuery('(max-width:900px)');

  useEffect(() => {
    setActiveItem(location.pathname);
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 999,
        transition: '0.3s',
        backgroundColor: location.pathname === '/'
          ? (scrolled ? '#1A425B' : 'transparent') // en inicio cambia al hacer scroll
          : '#1A425B',
        padding: '10px 0',
      }}
    >
      <Container maxWidth="xl" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {isMobile ? (
          <>
          <div>
            <Link to='/'>
              <img
                className="LogoNavbar"
                src={scrolled ? LogoColor : LogoColor}
                alt="HOD | Maquinas Dispensadoras"
                title="HOD | Maquinas Dispensadoras" />
            </Link>
            </div>
            <div>
            <IconButton edge="end" color="inherit" onClick={toggleDrawer(true)}>

              <div className="menu__icon">
                <span style={{ backgroundColor: scrolled ? '#ffff' : '#ffff' }}></span>
                <span style={{ backgroundColor: scrolled ? '#ffff' : '#ffff' }}></span>
                <span style={{ backgroundColor: scrolled ? '#ffff' : '#ffff' }}></span>
              </div>


            </IconButton>
            </div>
          </>
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>
            <Box >
              <Link to='/' >
                <img className="LogoNavbar" src={scrolled ? LogoColor : LogoColor} alt="HOD | Maquinas Dispensadoras"
                  title="HOD | Maquinas Dispensadoras" />
              </Link>
            </Box>
            <Box sx={{ display: 'flex', gap: 4, alignItems: "center", justifycontent: "center" }}>
              {menuItems.map((item, index) => (
                <Link
                  key={index}
                  to={item.path}
                  onClick={() => setDrawerOpen(false)}
                  className={
                    item.isButton
                      ? 'custom-button'
                      : `nav-link ${activeItem === item.path ? 'active' : ''}`
                  }
                  style={{
                    textDecoration: 'none',
                    border: item.isButton ? '0px solid #1976d2' : 'none',
                    borderRadius: item.isButton ? '20px' : 'none',
                    padding: item.isButton ? '6px 12px' : 0,
                    fontWeight: item.isButton ? 600 : 500,
                    fontSize: "0.9rem",
                    fontFamily: 'Montserrat',
                    cursor: 'pointer',
                  }}
                >
                  {item.name}
                </Link>
              ))}

            </Box>
          </Box>
        )}
      </Container>

      <SwipeableDrawer
        anchor="right"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        PaperProps={{
          sx: {
            backgroundColor: '#2C445F',
            color: '#FFFFFF',
          },
        }}
      >
        <Box sx={{
          width: 400, padding: 2, background: '#2C445F',
          color: '#FFFFFF',
          '@media (max-width:600px)': {
            padding: 1,
            width: '300px',
          },
          '@media (max-width:350px)': {
            padding: 1,
            width: '250px',
          },
          '@media (max-width:250px)': {
            padding: 1,
            width: '200px',
          },
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>

            <IconButton onClick={toggleDrawer(false)} sx={{ color: '#FFFFFF' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

            <img className="LogoNavbar" src={LogoColor} alt="HOD | Maquinas Dispensadoras"
              title="HOD | Maquinas Dispensadoras" />
          </Box>
          <List sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',

          }}>
            {menuItems.map((item, index) => (
              <Link
                key={index}
                to={item.path}
                  onClick={() => setDrawerOpen(false)}
                className={
                  item.isButton
                    ? 'custom-button'
                    : `nav-link ${activeItem === item.path ? 'active' : ''}`
                }
                style={{
                  marginBottom: '15px',
                  textDecoration: 'none',
                  border: item.isButton ? '0px solid #1976d2' : 'none',
                  borderRadius: item.isButton ? '20px' : 'none',
                  padding: item.isButton ? '6px 12px' : 0,
                  fontWeight: item.isButton ? 600 : 500,
                  fontSize: "0.9rem",
                  fontFamily: 'Montserrat',
                  cursor: 'pointer',
                }}
              >
                {item.name}
              </Link>
            ))}
          </List>
          <Box sx={{ mt: 4 }}>

            <Typography variant="subtitle1" sx={{
              fontWeight: 'bold', mb: 1, color: '#FFFFFF', fontFamily: 'Montserrat', '@media (max-width:600px)': {
                fontSize: '0.8rem'
              },
            }}>
              Contáctanos
            </Typography>
            <Box sx={{  mb: 1 }}>
              <a
  href="https://maps.app.goo.gl/kSvkKZXLFu3FxGp57"
  target="_blank"
  rel="noopener noreferrer"
  style={{ textDecoration: 'none',  display: 'flex', alignItems: 'center', mb: 1, color: '#FFFFFF', fontFamily: 'Montserrat' }}
>
              <LocationOnIcon sx={{
                mr: 1, '@media (max-width:600px)': {
                  fontSize: '1rem'
                },
              }} />
              <Typography variant="body2" sx={{
                fontFamily: 'Montserrat', '@media (max-width:600px)': {
                  fontSize: '0.8rem'
                },
              }}>San Ingnacio 030, Quilicura, Santiago</Typography>
              </a>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 10, color: '#FFFFFF', fontFamily: 'Montserrat' }}>
                   <a
  href="mailto:contacto@hod.com"
  target="_blank"
  rel="noopener noreferrer"
  style={{ textDecoration: 'none',  display: 'flex', alignItems: 'center', mb: 1, color: '#FFFFFF', fontFamily: 'Montserrat' }}
>
               
              <EmailIcon sx={{
                mr: 1, '@media (max-width:600px)': {
                  fontSize: '1rem'
                },
              }} />
              <Typography variant="body2" sx={{
                fontFamily: 'Montserrat', '@media (max-width:600px)': {
                  fontSize: '0.8rem'
                },
              }}>contacto@hod.cl</Typography>
              </a>
            </Box>
           {/*  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, color: '#FFFFFF', fontFamily: 'Montserrat' }}>
              <PhoneIcon sx={{
                mr: 1, '@media (max-width:600px)': {
                  fontSize: '1rem'
                },
              }} />
              <Typography variant="body2" sx={{
                fontFamily: 'Montserrat', '@media (max-width:600px)': {
                  fontSize: '0.8rem'
                },
              }}>+56 9 1234 5678</Typography>
            </Box> */}

            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
              <IconButton sx={iconButtonStyle} href="web.facebook.com/profile.php?id=61557919715539" target="_blank" rel="noopener" >
                <FacebookIcon />
              </IconButton>
              <IconButton sx={iconButtonStyle} href="https://www.instagram.com/hodvending" target="_blank" rel="noopener">
                <InstagramIcon />
              </IconButton>
              
              <IconButton sx={iconButtonStyle} href="https://www.linkedin.com/company/hod-servicios-logísticos/" target="_blank" rel="noopener">
                <FaLinkedinIn />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </SwipeableDrawer>
    </Box>
  );
};



const iconButtonStyle = {
  color: '#2C445F',
  with: '60px',

  height: '35px',
  backgroundColor: '#fff',
  borderRadius: '20px',
  padding: '5px ',
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: '#2C445F',
    color: '#fff',
    transform: 'scale(1.05)',
  },
  '&:active': {
    transform: 'scale(0.98)',
    backgroundColor: '#083a8c',
  },
};